module.exports = {
  text: `Их валуны разнесли наши стены, и через дыры вошли великаны с оружием в руках`,
  author: `капитан Дверн Адлестон, выживший во время осады Стернгейта`,
}
